/**
 * cn - merge Tailwind class names intelligently.
 *
 * Used by every shadcn/ui component. Wraps clsx (for conditional class merging)
 * with tailwind-merge (which deduplicates conflicting Tailwind classes, e.g.
 * cn("p-4", "p-8") returns "p-8" not "p-4 p-8").
 *
 * Import as: import { cn } from "@/lib/utils"
 * (Or: import { cn } from "src/lib/utils" if @/ path aliasing not set up.)
 *
 * Example:
 *   <div className={cn("bg-white p-4", isActive && "bg-brand", className)}>
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
